import { z } from 'zod';
export const FlowInputSchemaPropertySchema = z.object({
    id: z.string(),
    description: z.string(),
});
export const FlowInputSchemaSchema = z.object({
    properties: z.record(z.string(), FlowInputSchemaPropertySchema),
});
//# sourceMappingURL=inputSchema.js.map